/**
 * Created by evgeny on 15.05.2024
 */

const OldPiggyBankProgressBar = ScaledProgressBar.extend({
    ctor: function (mission) {
        const styles = cleverapps.styles.OldPiggyBankProgressBar;

        this._super({
            progress: bundles.progress_bar.frames.bar_green,
            background: bundles.progress_bar.frames.bg_green,
            to: mission.logic.getMaxAmount()
        });

        mission.logic.updateProgress = this.createListener(this.updateProgress.bind(this));
        this.mission = mission;
        this.setLength(styles.length);
        this.goalViews = this.addGoalViews();

        const lastShownAmount = mission.logic.getLastShowAmountProgress();
        this.setPercentage(lastShownAmount);

        const target = this.target = new cc.Node();
        this.addChild(target);
        this.updateTargetPosition();
    },

    addGoalViews: function () {
        const goals = this.mission.logic.getProgressGoals();
        const styles = cleverapps.styles.OldPiggyBankProgressBar;
        return goals.map((goal) => {
            const goalView = new OldPiggyBankGoalView(this.mission.logic.getGoal(goal));
            this.addChild(goalView);
            const position = this.width * this.mission.logic.calculateProgress(goal) + (styles.goalsOffset || 0);
            goalView.setPosition(position, this.height / 2);

            return goalView;
        });
    },

    updateTargetPosition: function () {
        const position = this.width * this.mission.result / this.mission.logic.getMaxAmount();
        this.target.setPosition(position, this.height / 2);
    },

    updateProgress: function () {
        if (Math.abs(this.mission.logic.getLastShowAmountProgress() - this.mission.result) < 0.01) {
            return;
        }

        const goals = this.goalViews;
        const amountProgress = this.mission.result;

        const stages = goals.filter((goal) => goal.amount <= amountProgress && goal.amount > this.mission.logic.getLastShowAmountProgress());

        cleverapps.effects.fire("piggybank.window.progress");

        let actions = [];

        if (stages.length) {
            actions = stages.map((stage) => new cc.Sequence(
                new cc.CallFunc(
                    () => {
                        this.setPercentage(stage.amount, {
                            animated: true,
                            delta: true,
                            callback: function () {
                                stage.showLight();
                                this.mission.logic.showBottomButtonPriceWithAnimation();

                                if (this.mission.result === stage.amount) {
                                    this.mission.logic.setBalance(this.mission.result);
                                }
                            }.bind(this)
                        });
                    }
                ),
                new cc.DelayTime(2)
            ));
        }

        actions.push(
            new cc.CallFunc(() => {
                this.setPercentage(this.mission.result, {
                    animated: true,
                    delta: true,
                    callback: function () {
                        this.mission.logic.setBalance(this.mission.result);
                    }.bind(this)
                });
            })
        );

        actions.push(new cc.CallFunc(() => {
            this.updateTargetPosition();
        }));

        this.runAction(new cc.Sequence(
            actions
        ));
    }
});

cleverapps.styles.OldPiggyBankProgressBar = {
    length: 550
};

if (cleverapps.config.ui === "heroes") {
    cleverapps.overrideStyles(cleverapps.styles.OldPiggyBankProgressBar, {
        goalsOffset: -10
    });
}